import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export async function getPartnerAvatarURL(): Promise<null | string> {
  const url = getM8PartnerURL(
    `getPartnerAvatar?${createQueryString({
      uniqueRuntimeKey: createUniqueRuntimeNumber(),
    })}`
  );

  const response = await fetch(url);

  if (response.ok) {
    return url;
  }

  return null;
}
